import { isDefined } from "@clipboard-health/util-ts";
import { isBefore, isSameMinute } from "date-fns";

export function hasShiftStarted({
  shiftStartDate,
  currentDate,
}: {
  shiftStartDate: Date;
  currentDate: Date;
}): boolean {
  return (
    isDefined(shiftStartDate) &&
    (isBefore(shiftStartDate, currentDate) || isSameMinute(shiftStartDate, currentDate))
  );
}
